// extracted by mini-css-extract-plugin
module.exports = {"container":"notification_container__2nyMK","container_active":"notification_container_active__3_2wD"};